// extracted by mini-css-extract-plugin
export default {"Button":"iStyles_Button__YiF46"};